
import { useState } from 'react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const galleryImages = [
    {
      src: 'https://public.readdy.ai/ai/img_res/3c3b0b411def522eaadd67f070a03a0b.jpg',
      alt: 'Panel Upgrade Installation'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=EV%20charger%20installation%20on%20garage%20wall%2C%20Tesla%20charging%20station%2C%20clean%20professional%20installation%2C%20modern%20home%20garage%20setting%2C%20bright%20lighting&width=600&height=400&seq=gallery-2&orientation=landscape',
      alt: 'EV Charger Installation'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=LED%20potlight%20recessed%20lighting%20installed%20in%20living%20room%20ceiling%2C%20modern%20home%20interior%2C%20even%20bright%20lighting%2C%20professional%20electrical%20installation&width=600&height=400&seq=gallery-3&orientation=landscape',
      alt: 'Potlight Installation'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Outdoor%20electrical%20work%2C%20exterior%20lighting%20installation%2C%20professional%20electrical%20service%2C%20clean%20installation%20on%20house%20exterior%2C%20bright%20daylight&width=600&height=400&seq=gallery-4&orientation=landscape',
      alt: 'Outdoor Electrical Work'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Commercial%20electrical%20installation%2C%20office%20building%20electrical%20work%2C%20professional%20electrical%20contractor%2C%20modern%20commercial%20setting%2C%20bright%20lighting&width=600&height=400&seq=gallery-5&orientation=landscape',
      alt: 'Commercial Electrical'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kitchen%20electrical%20renovation%2C%20new%20outlets%20and%20lighting%20installation%2C%20modern%20kitchen%20setting%2C%20professional%20electrical%20work%2C%20bright%20clean%20environment&width=600&height=400&seq=gallery-6&orientation=landscape',
      alt: 'Kitchen Electrical Renovation'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our <span className="text-yellow-600">Work Gallery</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Take a look at some of our recent electrical projects and installations throughout the GTA.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow"
              onClick={() => setSelectedImage(image.src)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-64 object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                <i className="ri-zoom-in-line text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl max-h-full p-4">
              <img
                src={selectedImage}
                alt="Gallery Image"
                className="max-w-full max-h-full object-contain"
              />
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 text-white text-3xl hover:text-gray-300 cursor-pointer"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
